import { NEUTRAL_COLORS, MAIN_COLORS } from 'src/shared/ColorStyles'
import { MAIN_FONT } from 'src/shared/TypographyStyles'
import { pStyle } from 'src/constants/fontStyles'
import { Props } from './index'

function getBaseHeight({ mode, type }: Pick<Props, 'mode' | 'type'>) {
  if (mode === 'multiple') {
    return 'min-height: 36px;'
  }

  if (mode === undefined) {
    switch (type) {
      case 'dropdown':
        return `height: 44px;`
      case 'filter':
        return `height: 36px;`
    }
  }

  return ''
}

function getPlaceholderColor({ type, disabled }: Pick<Props, 'type' | 'disabled'>) {
  if (disabled) {
    return `
      color: ${NEUTRAL_COLORS.G400};
    `
  }

  if (type === 'filter') {
    return `
      color: ${MAIN_COLORS.PRIMARY_BLACK};
      opacity: 1;
    `
  } else if (type === 'dropdown') {
    return `
      color: ${NEUTRAL_COLORS.G400};
      opacity: 1;
    `
  }

  return ''
}

function getSelectorPadding({ mode, type }: Pick<Props, 'mode' | 'type'>) {
  if (mode === 'multiple') {
    return ''
  }

  switch (type) {
    case 'dropdown':
      return `
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 15px;
        padding-right: 30px;
      `
    case 'filter':
      return `padding: 0 13px;`
    default:
      return ''
  }
}

function getBaseColor({ type }: Pick<Props, 'type'>) {
  switch (type) {
    case 'dropdown':
      return `color: ${NEUTRAL_COLORS.BLACK};`
    case 'filter':
      return `color: ${NEUTRAL_COLORS.G400};`
    default:
      return ''
  }
}

export default function({ mode, disabled, type }: Pick<Props, 'mode' | 'disabled' | 'type'>) {
  const style = `
    width: 100%;
    ${pStyle}
    ${getBaseColor({ type })}
    cursor: pointer;

    &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector, &.ant-select-multiple:not(.ant-select-customize-input) .ant-select-selector {
      ${getBaseHeight({ mode, type })}


      border-radius: 5px;
      border-color: ${NEUTRAL_COLORS.G200};
      ${getSelectorPadding({ mode, type })}

      &:hover {
        ${!disabled ? `border-color: ${MAIN_COLORS.PRIMARY_BLUE};` : ''}
      }

      &:active .ant-select-selection-placeholder {
        ${
          type === 'filter'
            ? `
          color: ${MAIN_COLORS.PRIMARY_BLUE};
        `
            : ''
        }
      }
    }

    &.ant-select-single.ant-select-focused:not(.ant-select-customize-input) .ant-select-selector, &.ant-select-multiple.ant-select-focused:not(.ant-select-customize-input) .ant-select-selector {
      border-color: ${MAIN_COLORS.PRIMARY_BLUE};
    }

    &.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
      display: flex;
      align-items: center;
      line-height: 34px;
      ${getPlaceholderColor({ type, disabled })}
    }

    &.ant-select-multiple .ant-select-selection-placeholder {
      display: flex;
      align-items: center;
      line-height: 34px;
      ${getPlaceholderColor({ type, disabled })}
    }

    &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
      height: 100%;
    }

    & .ant-select-selection-search > input {
      color: ${NEUTRAL_COLORS.BLACK};
      padding-bottom: 2px;
    }

    &.ant-select-single .ant-select-selector .ant-select-selection-item {
      display: flex;
      align-items: center;
      line-height: 34px;
      color: ${MAIN_COLORS.PRIMARY_BLACK};

      ${
        type === 'filter' && !disabled
          ? `
        color: ${MAIN_COLORS.PRIMARY_BLACK};
      `
          : ''
      }
    }

    &.ant-select-single.ant-select-show-arrow .ant-select-selection-item {
      padding-right: 15px;
    }

    &.ant-select-multiple .ant-select-selection-item {
      height: 28px;
      color: #FFFFFF;
      background: #2F8DEE;
      border-radius: 23px;
      border: 0;
      display: inline-flex;
      align-items: center;
      font-family: Inter;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      padding-left: 10px;
      cursor: pointer;
      font-family: ${MAIN_FONT};
    }

    &.ant-select-multiple .ant-select-selection-item-remove {
      font-size: 10px;
      color: #FFFFFF;
      padding-right: 5px;
      margin-top: 2px;
    }

    &.ant-select-multiple .ant-select-selection-item-content {
      margin-right: 3px;
    }

    &.ant-select-multiple .zoom-leave {
      display: none;
    }

    &.ant-select-multiple .ant-select-selection-placeholder {
      left: 16px;
      ${
        type === 'filter' && !disabled
          ? `
        color: ${MAIN_COLORS.PRIMARY_BLACK};
        opacity: 1;
      `
          : ''
      }
    }

    & .ant-select-selection-placeholder {
      opacity: 1;
    }

    &.ant-select-disabled.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
      color: ${NEUTRAL_COLORS.BLACK};
    }

    &.ant-select-disabled.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
      background: #F6F7F9;
    }

    & .ant-select-arrow .anticon.anticon-search {
      transform: scale(1.3);
      margin-left: -10px;
    }
  `

  return style
}
